import { render, staticRenderFns } from "./DataAudio.vue?vue&type=template&id=792f1470&scoped=true"
import script from "./DataAudio.vue?vue&type=script&lang=js"
export * from "./DataAudio.vue?vue&type=script&lang=js"
import style0 from "./DataAudio.vue?vue&type=style&index=0&id=792f1470&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "792f1470",
  null
  
)

export default component.exports